<lfw-project-list-view [data]="projects" (itemSelected)="onProjectSelected($event)" />
